import { baseConfig } from './data-dog.config';
import { getLogger } from './data-dog.util';

export const dataDogLogger = getLogger('FCT-FE', baseConfig);
